var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeaceSignal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5212 36.5442L39.5863 51.6941C39.5863 51.6941 35.9258 54.0739 25.8273 52.4086",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5212 36.5442L39.5863 51.6941C39.5863 51.6941 35.9258 54.0739 25.8273 52.4086",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 18.5302L27.1937 7.60131C27.5957 5.19223 29.9857 3.51819 32.5312 3.86444C35.0767 4.21069 36.8153 6.44372 36.4133 8.8528L35.3218 15.3934",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 18.5302L27.1937 7.60131C27.5957 5.19223 29.9857 3.51819 32.5312 3.86444C35.0767 4.21069 36.8153 6.44372 36.4133 8.8528L35.3218 15.3934",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7904 19.651L12.1122 11.4114C11.1058 9.15788 12.2135 6.58447 14.5859 5.66603C16.9583 4.74758 19.6975 5.82888 20.7054 8.08391L25.4972 18.8133",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7904 19.651L12.1122 11.4114C11.1058 9.15788 12.2135 6.58447 14.5859 5.66603C16.9583 4.74758 19.6975 5.82888 20.7054 8.08391L25.4972 18.8133",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6252 20.9998L30.8199 15.8016C32.9297 14.4034 35.8435 14.8832 37.3268 16.8726C38.8101 18.8621 38.301 21.6086 36.1912 23.0083L27.7755 27.8397C25.7802 29.1616 23.0659 28.8051 21.5225 27.0797",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6252 20.9998L30.8199 15.8016C32.9297 14.4034 35.8435 14.8832 37.3268 16.8726C38.8101 18.8621 38.301 21.6086 36.1912 23.0083L27.7755 27.8397C25.7802 29.1616 23.0659 28.8051 21.5225 27.0797",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6284 32.5542C24.4685 31.0254 25.1639 29.4629 26.5915 28.5165L35.0071 23.6852C37.1169 22.2869 40.0307 22.7667 41.514 24.7562C42.9973 26.7457 42.4882 29.4922 40.3784 30.8919L31.9628 35.7232C29.853 37.1215 26.9392 36.6417 25.4559 34.6522C24.9761 34.0081 24.7047 33.2848 24.6284 32.5542Z",
    fill: "white",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2564 38.2008C24.4336 31.2964 19.146 31.8084 19.146 31.8084C19.146 31.8084 23.2027 26.0615 21.7737 21.8273C20.3446 17.593 16.7545 17.5828 16.7545 17.5828L11.4419 28.9753C11.4419 28.9753 7.08 39.9688 19.0535 44.3923L18.0221 51.9335",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2564 38.2008C24.4336 31.2964 19.146 31.8084 19.146 31.8084C19.146 31.8084 23.2027 26.0615 21.7737 21.8273C20.3446 17.593 16.7545 17.5828 16.7545 17.5828L11.4419 28.9753C11.4419 28.9753 7.08 39.9688 19.0535 44.3923L18.0221 51.9335",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9661 31.4595C38.9661 31.4595 40.8793 43.8717 26.347 44.5099",
    stroke: "#303030",
    strokeWidth: 3.1507,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7407 43.2929C32.1377 43.4954 38.8324 41.9064 38.8324 41.9064L38.4509 37.0208C38.4509 37.0208 36.1519 42.1456 32.7407 43.2929Z",
    fill: "#303030"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8635 25.4956C12.8635 25.4956 8.47226 36.1282 16.3304 42.8302C16.3304 42.8302 11.1366 41.3733 10.6129 33.2041C10.6129 33.2041 9.85873 31.7369 12.8635 25.4956Z",
    fill: "#303030"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3512 33.0902C36.3512 33.0902 38.5945 36.3663 35.3212 41.563C35.3212 41.563 39.4322 37.9934 39.1593 33.2515C39.1183 33.1327 39.2136 31.9678 38.9818 31.5056L36.3512 33.0902Z",
    fill: "#303030"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1542 27.3831L38.0561 19.0247C38.0561 19.0247 38.7765 20.5094 36.5669 22.7718L28.1542 27.3831Z",
    fill: "#303030"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8165 38.8951L15.9592 39.413C15.9592 39.8913 15.9592 39.7681 15.9592 40.2464L12.8165 40.7643C11.0706 41.0519 9.70175 42.4207 9.41419 44.1666L8.89628 47.3093C8.41798 47.3093 8.54123 47.3093 8.06293 47.3093L7.54502 44.1666C7.25746 42.4207 5.88859 41.0519 4.14267 40.7643L1 40.2464C1 39.7681 1 39.8913 1 39.413L4.14267 38.8951C5.88859 38.6076 7.25746 37.2387 7.54502 35.4928L8.06293 32.3501C8.54123 32.3501 8.41798 32.3501 8.89628 32.3501L9.41419 35.4928C9.70322 37.2402 11.0706 38.6076 12.8165 38.8951Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5828,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0954 7.54502L48.2381 8.06293C48.2381 8.54123 48.2381 8.41798 48.2381 8.89628L45.0954 9.41419C43.3495 9.70175 41.9806 11.0706 41.6945 12.8165L41.1766 15.9592C40.6983 15.9592 40.8216 15.9592 40.3433 15.9592L39.8254 12.8165C39.5378 11.0706 38.1689 9.70175 36.423 9.41419L33.2818 8.89628C33.2818 8.41798 33.2818 8.54123 33.2818 8.06293L36.4245 7.54502C38.1704 7.25746 39.5393 5.88859 39.8268 4.14267L40.3447 1C40.823 1 40.6998 1 41.1781 1L41.696 4.14267C41.9821 5.89006 43.3495 7.25746 45.0954 7.54502Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5828,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceSignal);
export default __webpack_public_path__ + "static/media/peace-signal.512c68062f633e4eb021498e9e6cf111.svg";
export { ForwardRef as ReactComponent };